import * as React from "react";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { PsycheRadarControls } from "./Controls/PsycheRadarControls";
import { PsycheRadarSvg } from "./Svg/PsycheRadarSvg";

export function PsycheRadarView({ controller }: { controller: any }) {
    return (
        <div
            className={StyleClassAuto({
                position: "relative",
                width: "100%",
                maxWidth: `${Math.round(controller.size * 1.25)}px`,
                margin: "0 auto",
                padding: "0 0 4px",
                userSelect: "none",
                backgroundColor: "transparent",
            })}
        >
            <PsycheRadarSvg controller={controller} />
            <PsycheRadarControls controller={controller} />
        </div>
    );
}
